import { IconProps } from "../../types/utils";

const RoundRemoveIcon = ({ color, dimension, ...props }: IconProps) => (
  <svg
    width={dimension || 32}
    height={dimension || 32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_4792_24543)">
      <path
        d="M16 32C7.17725 32 0 24.8228 0 16C0 7.17725 7.17725 0 16 0C24.8228 0 32 7.17725 32 16C32 24.8228 24.8228 32 16 32ZM16 2C8.28003 2 2 8.28003 2 16C2 23.72 8.28003 30 16 30C23.72 30 30 23.72 30 16C30 8.28003 23.72 2 16 2Z"
        fill={color || "white"}
      />
      <path
        d="M11.0505 21.9492C10.7944 21.9492 10.5383 21.8521 10.3438 21.656C9.95312 21.2654 9.95312 20.6321 10.3438 20.2415L20.2437 10.3413C20.6345 9.95068 21.2678 9.95068 21.6584 10.3413C22.0491 10.7319 22.0491 11.3652 21.6584 11.7561L11.7583 21.656C11.561 21.8521 11.3052 21.9492 11.0505 21.9492Z"
        fill={color || "white"}
      />
      <path
        d="M20.9484 21.9492C20.6926 21.9492 20.4365 21.852 20.2419 21.6559L10.342 11.7573C9.95111 11.3666 9.95111 10.7333 10.342 10.3427C10.7326 9.95184 11.3659 9.95184 11.7565 10.3427L21.6564 20.2426C22.0473 20.6332 22.0473 21.2665 21.6564 21.6572C21.4606 21.852 21.2045 21.9492 20.9484 21.9492Z"
        fill={color || "white"}
      />
    </g>
    <defs>
      <clipPath id="clip0_4792_24543">
        <rect width="32" height="32" fill={color || "white"} />
      </clipPath>
    </defs>
  </svg>
);

export default RoundRemoveIcon;
